/* lg-desc-toggle.js - Block 72 (4 Sep). Restores the "Read More" control that
   PDP descriptions carry over from the old Turbo theme.

   The markup lives in product.description (body_html), not in Liquid, and is
   the W3Schools pattern: a <span class="dots">...</span> ellipsis, a
   <span class="more" style="display: none;"> holding the tail of the copy, and
   a <p class="myBtn">Read More</p> that used to call a global the theme never
   shipped. lg-readmore.js does NOT cover this - it binds #dotsOne/#moreOne/
   #myBtnOne, which exist only on the homepage brand story.

   #seo-text is measured, not assumed: on the catalogue it is an empty
   <div id="seo-text"><p> </p></div>, so it is used as a target only when it
   actually holds copy. The real target is .more.

   Scoped to the description accordion (.lg-content, from
   snippets/lg-product-accordions.liquid) so it cannot touch anything else, and
   idempotent so it can re-run after product-info.js swaps the buy-box. */
(function () {
  'use strict';

  var DONE = 'data-lg-desc-toggle';

  function textOf(el) {
    return el ? (el.textContent || '').replace(/\u00a0/g, ' ').trim() : '';
  }

  function setup(btn) {
    if (btn.getAttribute(DONE) === '1') return; // already wired
    var scope = btn.closest('.lg-content') || btn.parentElement;
    if (!scope) return;
    btn.setAttribute(DONE, '1');

    var dots = scope.querySelector('.dots');
    var more = scope.querySelector('.more');

    // Turbo also left an empty tab list behind. Drop it; keep anything with copy.
    var tabs = scope.querySelector('ul.tabs-content');
    if (tabs && !textOf(tabs)) tabs.parentNode.removeChild(tabs);

    var seo = scope.querySelector('#seo-text');
    if (seo && !textOf(seo)) seo = null; // empty on this catalogue: not a target

    var targets = [];
    if (more) targets.push(more);
    if (seo) targets.push(seo);

    // Nothing to reveal - hide the trigger rather than leave a dead control.
    if (!targets.length) {
      btn.hidden = true;
      return;
    }

    function apply(open) {
      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        if (t === more) {
          t.style.display = open ? 'inline' : 'none';
        } else {
          if (open) { t.removeAttribute('hidden'); } else { t.setAttribute('hidden', ''); }
        }
      }
      if (dots) dots.style.display = open ? 'none' : 'inline';
      btn.textContent = open ? 'Read Less' : 'Read More';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function toggle() {
      apply(btn.getAttribute('aria-expanded') !== 'true');
    }

    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    apply(false); // collapsed to match the inline display:none the markup ships with

    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle();
      }
    });
  }

  function init() {
    var btns = document.querySelectorAll('.product__description .myBtn, .lg-content .myBtn');
    Array.prototype.forEach.call(btns, setup);
  }

  function start() {
    init();
    // product-info.js replaces #LgBuyboxExtras-* innerHTML on variant change,
    // which discards the description and every listener on it. Re-wire what
    // comes back. setup() is guarded by DONE, so this cannot double-bind.
    var extras = document.querySelector('[id^="LgBuyboxExtras-"]');
    if (!extras || typeof MutationObserver !== 'function') return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; init(); });
    }).observe(extras, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
